import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Generic rule-screen layout: back link + title + summary tiles + filter bar +
// content (flagged-records table etc.). Used by the built rules (Subhadra,
// Member) and ready for the future ones.
//
// Props: title, subtitle, icon, backTo, backLabel, tiles (nodes), filterBar (node), children
export default function RuleScreen({
  title,
  subtitle,
  icon: Icon,
  backTo,
  backLabel = 'Back',
  tiles,
  filterBar,
  children,
}) {
  return (
    <div className="page">
      {backTo ? (
        <Link to={backTo} className="back-link">
          <ArrowBackIcon fontSize="small" /> {backLabel}
        </Link>
      ) : null}
      <div className="page-header">
        <h1 className="page-title">
          {Icon ? <Icon /> : null} {title}
        </h1>
        {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
      </div>
      {tiles ? <div className="stat-tile-row">{tiles}</div> : null}
      {filterBar}
      {children}
    </div>
  );
}
